// Script Uses Intersection Observer to support
require('intersection-observer');

module.exports = function () {
    // Video Lazy Load
    var videos = document.querySelectorAll('.page-header-video');
    videos = Array.from(videos);
    if ( videos ) {
    console.log(videos);
    var srcObserver = new IntersectionObserver( function(entries) {
        entries.forEach(function(entry) {
        if (entry.intersectionRatio > 0) {
            var source = entry.target.getAttribute('data-src');
            entry.target.innerHTML = '<source src="' + source + '" type="video/mp4">';
            srcObserver.unobserve(entry.target);
        }
        });
    }, {
        rootMargin: '20% 0%'
    });

    videos.forEach(function(video) {
        srcObserver.observe(video);
    });
    }

    // Pause Video if outside the viewport
    var myVideos = document.querySelectorAll('.page-header-video');
    myVideos = Array.from(myVideos);

    var videoObserver = new IntersectionObserver( function(entries) {
    entries.forEach( function(entry) {
        if (entry.intersectionRatio > 0) {
        playVideo(entry.target);
        } else {
        pauseVideo(entry.target);
        }
    });
    }, {
        rootMargin: '0px'
    });

    myVideos.forEach( function(video) {
        videoObserver.observe(video);
    });

    function playVideo(video) {
        console.log('play');
        video.play();
    }

    function pauseVideo(video) {
        console.log('pause');
        video.pause();
    }
}